import React, { Component } from 'react';
import {connect} from 'react-redux';
import './App.css';
import CircularProgress from 'material-ui/CircularProgress';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import AppMain from './containers/appMain';
import ErrorDialog from './components/errorDialog.component';
import SupportDialog from './components/supportDialog.component';
import Header from './components/header.component';
import resetErrorMessage from './actions/resetErrorMessageAction';
import logoutAction from './actions/logoutAction';
import history from './routers/history';
import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import getHelpMixpanel from './actions/mixpanel/getHelpMixpanel';

BigCalendar.setLocalizer(
   BigCalendar.momentLocalizer(moment)
);

const muiTheme = getMuiTheme({
   palette: {
      primary1Color: '#258df2',
      accent1Color: '#ff0077',
   }
});

class App extends Component {

   constructor(props) {
      super(props);
      this.state = {
         showSupportDialog: false
      };
      this.toggleSupportDialogState = this.toggleSupportDialogState.bind(this);
   }

   handleDismissClick(e)  {
      this.props.resetErrorMessage();
      e.preventDefault();
   }

   renderErrorMessage() {
      if (this.props.errorMessage) {
         return (
            <ErrorDialog
               errorMessage = {this.props.errorMessage}
               handleClose = {this.handleDismissClick.bind(this)}
            />
         )
      }
      return null;
   }

   renderProgressCircle() {
      if (this.props.asyncActionsCount > 0) {
         return <CircularProgress className="loading" size={60} thickness={6}/>
      }
      return null;
   }

   renderSupportDialog() {
      return <SupportDialog open = {this.state.showSupportDialog}
         handleClose = {this.toggleSupportDialogState}/>
   }

   handleLogout() {
      localStorage.removeItem("viboLastLogin");
      this.props.logout();
      history.push('/login');
   }

   toggleSupportDialogState = () => {
      this.props.getHelpMixpanel(this.props.userData);
      this.setState({
         showSupportDialog: !this.state.showSupportDialog
      });
   }

   render() {
      muiTheme.button.textTransform = 'none';
      return (
         <div className="App">
            <MuiThemeProvider muiTheme={muiTheme}>
               <div>
                  <div style={{ opacity: this.props.asyncActionsCount > 0 ? 0.3 : 1}}>
                     <Header
                        loggedIn = {this.props.loggedIn}
                        logout = {this.handleLogout.bind(this)}
                        handleSupportButtonClicked = {this.toggleSupportDialogState}
                     />
                     <AppMain />
                  </div>
                  {this.renderProgressCircle()}
                  {this.renderErrorMessage()}
                  {this.renderSupportDialog()}
               </div>
            </MuiThemeProvider>
         </div>
      );
   }
}

const mapStateToProps = (state) => ({
   loggedIn: state.user.loggedIn,
   errorMessage: state.errorMessage,
   asyncActionsCount: state.asyncActionsCount,
   userData: state.user.data,
})

const mapDispatchToProps = {
   resetErrorMessage : resetErrorMessage,
   logout: logoutAction,
   getHelpMixpanel: getHelpMixpanel,
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js